export enum TMode {
    doc = 'doc',
    propsEditor = 'propsEditor'
}

export const DEFAULT_MODE = TMode.doc;
